import { render } from "./Index.vue?vue&type=template&id=0a44b325&scoped=true&ts=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"

import "./Index.vue?vue&type=style&index=0&id=0a44b325&lang=scss&scoped=true"

import exportComponent from "/home/project/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a44b325"]])

export default __exports__